import { useQuery } from '@tanstack/react-query';

import { BaseError } from '../../helpers/BaseError';

import { CustomSurfaceTemplateDetailModel } from '../../models/custom-surface-template.model';

import API from '../../services/api';

import customSurfaceTemplateKeys from './_queryKeys';

const getCustomSurfaceTemplate = async (id: string) => {
    const { data } = await API.getCustomSurfaceTemplate(id);
    return data;
};

export default function useGetCustomSurfaceTemplate(
    id: string,
    enabled: boolean = true,
) {
    return useQuery<CustomSurfaceTemplateDetailModel, BaseError>({
        queryKey: customSurfaceTemplateKeys.detail(id),
        queryFn: () => getCustomSurfaceTemplate(id),
        staleTime: 2 * 60 * 60 * 1000, // 2 hours
        enabled,
    });
}
